import { FC, memo } from 'react';
import Events from '../../components/Events/Events';
import { useEventsScreen } from '../../hooks/screens/useEventsScreen';

const EventsScreen: FC = memo(() => {
  const props = useEventsScreen();
  return <Events {...props} />;
});

EventsScreen.displayName = 'EventsScreen';
export default EventsScreen;
